
import React from 'react';
import { 
  ShieldCheck, 
  Briefcase, 
  Settings, 
  FileText, 
  Layers, 
  TrendingUp,
  Scale,
  Zap,
  Users,
  Building2,
  FileStack,
  Workflow,
  Globe,
  CalendarClock
} from 'lucide-react';
import { ServiceItem, ValueItem } from './types';

export const COMPANY_NAME = "AVUS Business Services LLC";
export const LOCATION = "Doha, State of Qatar";
export const CR_NUMBER = "236038";
export const ESTABLISHED = "2026";
export const PHONE = "+974 7193 1621";
export const EMAIL = "info@avus.qa";
export const WEBSITE = "www.avus.qa";

// Social Media Links
export const LINKEDIN_URL = "https://www.linkedin.com/company/avusbusiness/";
export const X_URL = "https://x.com/avusbusiness?s=21";
export const FACEBOOK_URL = "https://www.facebook.com/share/189yN4UGwT/";
export const WHATSAPP_BASE_URL = "https://wa.me/97471931621";

export const getWhatsAppLink = (message: string) => {
  return `${WHATSAPP_BASE_URL}?text=${encodeURIComponent(message)}`;
};

export const WHATSAPP_URL = getWhatsAppLink("Hello AVUS, I would like to inquire about your professional business services in Qatar.");

export const SERVICES: ServiceItem[] = [
  {
    title: "Business Support Services",
    description: "Your trusted operational partner for back-office and administrative functions.",
    subItems: ["Corporate admin support", "Office documentation", "Vendor coordination"],
    icon: "Briefcase"
  },
  {
    title: "Company Formation & CR",
    description: "Guidance through the procedural aspects of business setup and maintenance.",
    subItems: ["MOCI portal assistance", "License renewals", "Manager changes"],
    icon: "Building2"
  },
  {
    title: "Regulatory & Compliance",
    description: "Helping businesses stay organized, audit-ready, and fully compliant.",
    subItems: ["Internal checklists", "Filing coordination", "Gap identification"],
    icon: "ShieldCheck"
  },
  {
    title: "Documentation & Filing",
    description: "Structured support for your entire business documentation lifecycle.",
    subItems: ["Record organization", "Digitization systems", "Regulator formatting"],
    icon: "FileStack"
  },
  {
    title: "Process & Operations",
    description: "Standardizing and improving how your business operates daily.",
    subItems: ["Process mapping", "SOP structuring", "Efficiency reviews"],
    icon: "Workflow"
  },
  {
    title: "Investor & Foreign Support",
    description: "Navigating Qatar's business environment for international entities.",
    subItems: ["Market entry coordination", "Governance structuring", "Liaison support"],
    icon: "Globe"
  },
  {
    title: "Administration Retainers",
    description: "Monthly support packages providing ongoing operational peace of mind.",
    subItems: ["Dedicated support officer", "Monthly health checks", "Expiry monitoring"],
    icon: "CalendarClock"
  }
];

export const VALUES: ValueItem[] = [
  {
    title: "Integrity",
    description: "Transparent and ethical action.",
    longDescription: "We act transparently and ethically at all times, maintaining trust and professionalism in every engagement.",
    icon: "Scale"
  },
  {
    title: "Compliance First",
    description: "Regulator-aligned approach.",
    longDescription: "We prioritize regulatory alignment, ensuring all operations fall strictly within the legal framework of Qatar.",
    icon: "ShieldCheck"
  },
  {
    title: "Client Performance",
    description: "Enabling focus on core growth.",
    longDescription: "We remove administrative friction, allowing you to focus on your core mission and performance.",
    icon: "TrendingUp"
  }
];

export const getIcon = (name: string, size = 24, className = "") => {
  const icons: Record<string, any> = {
    Briefcase: <Briefcase size={size} className={className} />,
    Building2: <Building2 size={size} className={className} />,
    ShieldCheck: <ShieldCheck size={size} className={className} />,
    FileStack: <FileStack size={size} className={className} />,
    Workflow: <Workflow size={size} className={className} />,
    Globe: <Globe size={size} className={className} />,
    CalendarClock: <CalendarClock size={size} className={className} />,
    TrendingUp: <TrendingUp size={size} className={className} />,
    Scale: <Scale size={size} className={className} />,
    Zap: <Zap size={size} className={className} />,
    Users: <Users size={size} className={className} />
  };
  return icons[name] || <Briefcase size={size} className={className} />;
};
